import { render, staticRenderFns } from "./ListColiseumBrain.vue?vue&type=template&id=c231192a&scoped=true"
import script from "./ListColiseumBrain.vue?vue&type=script&lang=js"
export * from "./ListColiseumBrain.vue?vue&type=script&lang=js"
import style0 from "./ListColiseumBrain.vue?vue&type=style&index=0&id=c231192a&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c231192a",
  null
  
)

export default component.exports